/**
 * All conversation action IDs - single source of truth.
 * These IDs connect action definitions, scopes, and handlers at compile time.
 */
export const conversationActionIds = {
  // Table navigation
  navigateUp: "navigateUp",
  navigateDown: "navigateDown",
  openConversation: "openConversation",
  openActionMenu: "openActionMenu",

  // Direct conversation actions
  close: "close",
  reopen: "reopen",
  snooze: "snooze",
  archive: "archive",
  delete: "delete",
  markRead: "markRead",
  markUnread: "markUnread",

  // Submenu trigger actions
  setPriority: "setPriority",
  assign: "assign",
  addTag: "addTag",

  // Priority options
  priorityUrgent: "priorityUrgent",
  priorityClear: "priorityClear",

  // Snooze options
  snooze1h: "snooze1h",
  snooze4h: "snooze4h",
  snooze24h: "snooze24h",
  snoozeCustom: "snoozeCustom",
  snoozeClear: "snoozeClear",

  // Message input actions
  sendMessage: "sendMessage",
  deleteDraft: "deleteDraft",

  // Reply mode actions
  reply: "reply",
  replyAll: "replyAll",
  forward: "forward",
} as const;

export type ConversationActionId =
  (typeof conversationActionIds)[keyof typeof conversationActionIds];

const conversationActionIdSet = new Set<string>(
  Object.values(conversationActionIds),
);

export function isConversationActionId(id: string): id is ConversationActionId {
  return conversationActionIdSet.has(id);
}
